// ======================================
// Author: Ebenezer Monney
// Copyright (c) 2023 www.ebenmonney.com
// 
// ==> Gun4Hire: contact@ebenmonney.com
// ======================================

export const environment = {
  production: false,
  baseUrl: 'https://swedishwelcometest-api.devisor.se', // API now hosted separately from the frontend (Azure Static Web App)
  loginUrl: '/login',
  googleClientId: null,
  facebookClientId: null,
  microsoftClientId: null
};
